import { render, staticRenderFns } from "./salesoppo.vue?vue&type=template&id=4dbbbb88&scoped=true"
import script from "./salesoppo.vue?vue&type=script&lang=js"
export * from "./salesoppo.vue?vue&type=script&lang=js"
import style0 from "./salesoppo.vue?vue&type=style&index=0&id=4dbbbb88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dbbbb88",
  null
  
)

export default component.exports